import { MdModeEdit } from "react-icons/md";
import { useNavigate } from "react-router-dom";

const LayoutListItem = (props: any) => {
    const navigate = useNavigate()
    const { layout } = props

    const editLayoutHandler = () => {
        navigate(`/layout/${layout.id}/edit`)
        return
    }

    //Date on the first line, time on the second
    const dateTimeCell = (_date: any) => {
        if (!_date) return "N/A"
        let d = new Date(_date)
        return (<>
            <span>{d.toLocaleDateString()}</span>
            <span className="block time-txt">{d.toLocaleTimeString()}</span>
        </>)
    }

    return (<>
        <tr>
            <td className="">{layout.id}</td>
            <td className="">
                <span onClick={() => navigate(`/layout/${layout.id}`)} className="layout-name text-blue-500 cursor-pointer">{layout.layoutName}</span>
                <span className="block layout-id">Code: {layout.layoutCode}</span>
            </td>
            <td className="">{layout.device}</td>
            <td className="">{layout.createdBy}</td>
            <td className="">{dateTimeCell(layout.createdAt)}</td>
            <td className="">{dateTimeCell(layout.modifiedAt)}</td>
            <td className="">
                <span className={`status-badge ${layout.status ? "active" : "inactive"}`}>
                    {layout.status ? "Active" : "Inactive"}
                </span>
            </td>
            <td className="action flex mt-[10px]">
                <div onClick={editLayoutHandler} className="action-inner">
                    <MdModeEdit />
                    <p className="action-name px-[10px] py-[5px]">Edit&nbsp;Page</p>
                </div>
            </td>
        </tr>
    </>)

}

export default LayoutListItem
